module.exports = __webpack_public_path__ + "img/camera_rolate.3910134a.svg";